import { groq } from '#imports';

export function getQuery({ slug } = {}) {
  return groq`*[_type == "staff" && slug.current == "${slug}" && !(_id in path('drafts.**'))][0]`;
}
